package cc.bluepeak.clubmanager.site

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import cc.bluepeak.clubmanager.site.styles.COLOR_MODE_KEY
import cc.bluepeak.clubmanager.site.styles.Theme
import cc.bluepeak.clubmanager.site.styles.Theme.darkBackground
import cc.bluepeak.clubmanager.site.styles.Theme.lightBackground
import cc.bluepeak.clubmanager.site.styles.backgroundColor
import cc.bluepeak.clubmanager.site.util.gsap
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.setVariable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import kotlinx.browser.localStorage
import kotlinx.browser.window
import org.jetbrains.compose.web.css.vh
import org.w3c.dom.HTMLElement
import org.w3c.dom.MediaQueryListEvent

private fun colorModeQuery() = window.matchMedia("(prefers-color-scheme: dark)")

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    var colorMode by ColorMode.currentState
    DisposableEffect(Unit) {
        colorMode = if (colorModeQuery().matches) ColorMode.DARK else ColorMode.LIGHT
        colorModeQuery().addEventListener("change", {
            localStorage.getItem(COLOR_MODE_KEY) ?: let { _ ->
                colorMode = (if (it is MediaQueryListEvent && it.matches) ColorMode.DARK else ColorMode.LIGHT)
            }
        })
        gsap.registerPlugin(js("ScrollTrigger"))
        onDispose { }
    }

    DisposableEffect(colorMode) {
        (document.body!!.parentElement as HTMLElement).setVariable(
            backgroundColor,
            if (colorMode.isLight) lightBackground else darkBackground
        )
        onDispose { }
    }
    SilkApp {
        Surface(
            SmoothColorStyle.toModifier().scrollBehavior(ScrollBehavior.Smooth)
                .backgroundColor(backgroundColor.value(Theme.lightBackground))
        ) {
            Box(Modifier.minHeight(100.vh)) {
                content()
            }
        }
    }
}